export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-nl-NL.2c82d914.xlsx";